import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, Smartphone, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, logout, user } = useAuth();

  const navLinks = [
    { name: 'Inicio', path: '/' },
    { name: 'Servicios', path: '/services' },
    { name: 'Tienda', path: '/shop' },
    { name: 'Opiniones', path: '/reviews' },
    { name: 'Galería', path: '/gallery' },
    { name: 'Sobre Nosotros', path: '/about' },
    { name: 'Contacto', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    logout();
    navigate('/');
    setIsOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-slate-900/80 backdrop-blur-lg border-b border-slate-800">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="https://customer-assets.emergentagent.com/job_device-repair-pro-18/artifacts/hify6q1n_ChatGPT%20Image%201%20jun%202026%2C%2002_59_04%20p.m..png"
              alt="KROLBOLT"
              className="h-12 w-auto group-hover:scale-105 transition-transform duration-300"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link key={link.path} to={link.path}>
                <Button 
                  variant="ghost" 
                  className={`text-slate-300 hover:text-white transition-colors ${
                    isActive(link.path) 
                      ? 'bg-cyan-500/10 text-cyan-400' 
                      : 'hover:bg-slate-800'
                  }`}
                >
                  {link.name}
                </Button>
              </Link>
            ))}
            {isAuthenticated && (
              <>
                <Link to="/admin">
                  <Button 
                    variant="outline" 
                    className="ml-2 border-cyan-500 text-cyan-400 hover:bg-cyan-500/10"
                  >
                    Admin
                  </Button>
                </Link>
                <Button 
                  variant="ghost"
                  onClick={handleLogout}
                  className="ml-2 text-slate-400 hover:text-red-400"
                  title="Cerrar sesión"
                >
                  <LogOut className="h-4 w-4" />
                </Button>
              </>
            )}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <nav className="md:hidden py-4 space-y-2">
            {navLinks.map((link) => (
              <Link key={link.path} to={link.path} onClick={() => setIsOpen(false)}>
                <Button 
                  variant="ghost" 
                  className={`w-full justify-start text-slate-300 hover:text-white ${
                    isActive(link.path) 
                      ? 'bg-cyan-500/10 text-cyan-400' 
                      : 'hover:bg-slate-800'
                  }`}
                >
                  {link.name}
                </Button>
              </Link>
            ))}
            {isAuthenticated && (
              <>
                <Link to="/admin" onClick={() => setIsOpen(false)}>
                  <Button 
                    variant="outline" 
                    className="w-full justify-start border-cyan-500 text-cyan-400 hover:bg-cyan-500/10"
                  >
                    Admin
                  </Button>
                </Link>
                <Button 
                  variant="ghost"
                  onClick={handleLogout}
                  className="w-full justify-start text-red-400 hover:bg-red-500/10"
                >
                  <LogOut className="mr-2 h-4 w-4" />
                  Cerrar Sesión
                </Button>
              </>
            )}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;